import { Download } from 'lucide-react';

import useTranslation from '../../../../shared/hooks/useTranslation';
import { useSelectionExportStore } from '../../store/useSelectionExportStore';

import styles from './SelectionExportProgress.module.css';

export const SelectionExportProgress = () => {
  const { t } = useTranslation();
  const isExporting = useSelectionExportStore((state) => state.isExporting);
  const loadedFiles = useSelectionExportStore((state) => state.loadedFiles);
  const totalFiles = useSelectionExportStore((state) => state.totalFiles);
  const cancelExport = useSelectionExportStore((state) => state.cancelExport);

  if (!isExporting) {
    return null;
  }

  const progressPercentage = totalFiles > 0
    ? Math.round((loadedFiles / totalFiles) * 100)
    : 0;

  return (
    <div className={styles.wrapper} role="status" aria-live="polite">
      <div className={styles.header}>
        <div className={styles.icon}>
          <Download size={16} />
        </div>
        <div className={styles.title}>
          {t('home.selectionExport.progressTitle')}
        </div>
        <button
          type="button"
          onClick={cancelExport}
          className={styles.cancelButton}
        >
          {t('home.selectionExport.cancel')}
        </button>
      </div>

      <div className={styles.progressContainer}>
        <div className={styles.progressInfo}>
          <span>
            {t('home.selectionExport.progressFiles', {
              current: loadedFiles,
              total: totalFiles,
            })}
          </span>
          <span className={styles.percentage}>{progressPercentage}%</span>
        </div>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectionExportProgress;
